import { ArrowLeft, Printer } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatMoney, mmYYYY } from "@/lib/money";
import { StatusPill } from "@/components/inventory/Grns";

const KEYS = ["ordered", "received", "damaged", "short", "accepted"];

function printGrn(g, biz, branch) {
  const m = (v) => formatMoney(v, biz.decimals);
  const rows = g.lines.map((l) => `<tr><td>${l.name}${l.batch_no ? `<br><small>Batch ${l.batch_no} · exp ${mmYYYY(l.expiry)}</small>` : ""}</td>${KEYS.map((k) => `<td class=r>${l[k]}</td>`).join("")}<td class=r>${l.cost}</td><td class=r>${m(l.line_cost_minor)}</td></tr>`).join("");
  const w = window.open("", "_blank");
  w.document.write(`<html><head><title>${g.number}</title><style>body{font:13px system-ui;padding:24px}table{width:100%;border-collapse:collapse}td,th{border-bottom:1px solid #ddd;padding:6px;text-align:left}.r{text-align:right}h1{margin:0}</style></head><body>
<h1>Goods Received Note ${g.number}</h1><p>${biz.name} · ${branch.name}<br>Supplier: <b>${g.supplier}</b> · Invoice ${g.invoice_no} (${g.invoice_date})<br>Posted ${(g.posted_at || "").slice(0, 16).replace("T", " ")}</p>
<table><tr><th>Product</th><th class=r>Ordered</th><th class=r>Received</th><th class=r>Damaged</th><th class=r>Short</th><th class=r>Accepted</th><th class=r>Cost</th><th class=r>Line</th></tr>${rows}
<tr><th>Totals</th>${KEYS.map((k) => `<th class=r>${g.totals[k]}</th>`).join("")}<th></th><th class=r>${biz.currency} ${g.totals.cost_str}</th></tr></table>
<p style="margin-top:40px">Received by: ____________________ &nbsp; Checked by: ____________________</p></body></html>`);
  w.document.close();
  w.focus();
  w.print();
}

export function GrnTotals({ t, currency }) {
  return (
    <div className="grid grid-cols-3 gap-2 sm:grid-cols-6" data-testid="grn-totals">
      {[...KEYS, "cost"].map((k) => (
        <div key={k} className="rounded-xl bg-slate-950 px-3 py-2 text-white">
          <div className="font-mono text-[10px] uppercase tracking-wider text-slate-400">{k === "cost" ? "Total cost" : k}</div>
          <div className="font-mono text-lg font-bold text-amber-400" data-testid={`grn-total-${k}`}>{k === "cost" ? `${currency} ${t.cost_str}` : t[k]}</div>
        </div>
      ))}
    </div>
  );
}

export function GrnView({ grn: g, onClose }) {
  const { session } = useAuth();
  const biz = session.business;
  return (
    <div className="space-y-4" data-testid="grn-view">
      <div className="flex flex-wrap items-center gap-3">
        <button onClick={onClose} className="grid h-10 w-10 place-items-center rounded-xl border border-slate-200" aria-label="Back" data-testid="grn-back"><ArrowLeft className="h-4 w-4" /></button>
        <div className="font-display text-xl font-bold">{g.number}</div>
        <StatusPill s={g.status} id="grn-view-status" />
        <button onClick={() => printGrn(g, biz, session.branch)} className="ml-auto flex h-10 items-center gap-2 rounded-xl bg-slate-900 px-4 text-sm font-bold text-white" data-testid="grn-print"><Printer className="h-4 w-4" />Print GRN</button>
      </div>
      <div className="text-sm text-slate-600">Supplier <b className="text-slate-900">{g.supplier}</b> · Invoice <b className="font-mono">{g.invoice_no}</b> · {g.invoice_date} · read-only</div>
      <GrnTotals t={g.totals} currency={biz.currency} />
      <div className="divide-y divide-slate-100 rounded-2xl border border-slate-200 bg-white">
        {g.lines.map((l, i) => (
          <div key={i} className="flex flex-wrap items-center gap-x-4 gap-y-1 px-4 py-3 text-sm" data-testid={`grn-view-line-${i}`}>
            <span className="font-semibold text-slate-900">{l.name}</span>
            {l.batch_no && <span className="font-mono text-xs text-slate-500">Batch {l.batch_no} · exp {mmYYYY(l.expiry)}</span>}
            <span className="ml-auto font-mono text-xs">{KEYS.map((k) => `${k} ${l[k]}`).join(" · ")} · cost {l.cost}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
